import { api } from "./http";

export const flashcardApi = {
  getAll: () => api.get("/flashcards"),
  getById: (id) => api.get(`/flashcards/${id}`),
  create: (data) => api.post("/api/FlashCard/flashcard", data),
  update: (data) => api.put(`/api/FlashCard/flashcard`, data),
  remove: (id) => api.delete(`/api/FlashCard/flashcard?id=${id}`),
  getTable: (param) => api.post("/api/FlashCard/table", param),
  importByFile: (formData) => api.post("/api/FlashCard/import", formData),
};
